<template>
  <div/>
</template>

<script>
export default {
  name: 'AbilityApplyMemberService',
  mounted() {
    const id = this.$route.query.id;
    rbLink({
      name: 'AbilityApplyStep2',
      query: id ? { id } : {},
    }, 'replace');
  },
};
</script>



// WEBPACK FOOTER //
// AbilityApplyMemberService.vue?850fc84c